<template>
  <div class="article-column">

      <article-list-skeleton v-if="loading" style="margin-bottom: 100vh"></article-list-skeleton>

      <div class="article-column-head">
          <div class="article-column-head-title">
              <img src="/static/img/icon_list_tag_column.svg" alt="">
              {{article.title}}
          </div>
          <div class="article-column-head-detail">
              已更新{{article.current_count}}篇 | 共{{article.total_count}}篇
          </div>
      </div>

      <div class="article-column-body">
          <div class="article-list-section" v-if="article.items.length > 0">
              <van-row class="article-list-section-box" @click="goArticle(item)" v-for="item in article.items" :key="item.id">
                  <van-col span="8">
                      <van-image
                          fit="cover"
                          class="article-list-content-img"
                          :src="item.cover_img"
                          width="100%"
                          height="74"
                      />
                  </van-col>
                  <van-col span="16" class="article-list-content">
                      <div class="article-list-title">{{item.title.length > 34 ? item.title.substr(0,34)+'...' : item.title}}</div>
<!--                      <div class="article-list-content-desc">
                          {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                      </div>-->
                      <div class="article-list-content-detail">
                          <div>
                              {{item.created_at}}
                              <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                          </div>
                      </div>
                  </van-col>
              </van-row>
          </div>
          <div class="van-list__finished-text" v-if="article.items.length > 0 && page === total_page">没有更多了</div>
          <div v-else-if="article.items.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
          <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
              <template slot="description">
                  <div style="text-align: center">没有更多了</div>
                  <div style="text-align: center">博医荟GoBroad持续更新中…</div>
                  <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                  <div style="text-align: center;margin-top: 24px">
                      <van-button color="#D3172E" round size="small" style="width: 120px" @click="$toHomePage">
                          返回首页
                      </van-button>
                  </div>
              </template>
          </van-empty>
      </div>
  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import articleListSkeleton from "@/skeleton/articleListSkeleton"
    export default {
        name: 'article-list',
        components :{
            'article-list-skeleton' : articleListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,
                id:0,
                article:{
                    items:[]
                }
            }
        },
        methods: {
            onSearch(){
                this.fetch('article')
            },
            onCancel() {
                this.value = ""
                this.fetch("article")
            },
            fetch(scene) {
                if (scene === 'article') {
                    Interface.getData('get', Interface.article.detail+'/'+this.id).then((res) => {
                        if(res.data.items==null){
                            res.data.items = []
                        }
                        this.article = res.data
                        if(this.article){
                            Interface.getShareInfo(this,this.article.title,"",this.article.desc,false)
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.article.list,params).then((res) => {
                    this.article.items.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            goArticle(item){
                this.$router.push({'name':'article-detail',params:{id:item.id}})
            },
            setCurrentUrl: () => {
                let url = location.href.replace(/&wx=[-]{}/g, '');
                window.history.replaceState({}, document.title, url);
            }
        },
        created() {
            this.setCurrentUrl()
            this.id = this.$route.params.id
            this.fetch('article')
            // let obj = [{ origin_id: Number(this.id), type: 73, title: '临床招募项目列表页', page_type: 4}]
            // Interface.exposureFootPrint(JSON.stringify(obj))

        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/article/column/index.vue